import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useCallback,
} from "react";
import { NavLink } from "react-router-dom";
import {
  Autocomplete,
  Grid,
  TextField,
  CircularProgress,
  LinearProgress,
  Button,
  Box,
  Collapse,
} from "@mui/material";
import ReactPaginate from "react-paginate";
import Table from "../../Components/Common/Table/Table";
import {
  getInfoMessageNoResultsSearch,
  CommonSubHeader,
} from "../../Components/helpers/Helpers";
import Swal from "sweetalert2";
import TableActions from "../../Components/Common/Table/TableActions";
import {
  CleaningServices,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PersonAdd,
  Search,
} from "@mui/icons-material";
import api from "../../api/axios";
import { CustomButtonPlusIcon } from "../../Components/Common/Design/CustomButtonPlusIcon";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

function Usuarios({
  flagToShow = true,
  setCompanyFromUser = 0,
  setUsersControlNumber,
}) {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [showFilters, setShowFilters] = useState(true);

  const handleSort = (column, direction) => {
    console.log(column, direction);
    setSortColumn(column);
    setSortDirection(direction);
    setPagePressed(1); // reinicia paginación
  };

  const [user, setUser] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [pagePressed, setPagePressed] = useState(1);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [flag, setFlag] = useState(false);
  const [changeDone, setChangeDone] = useState(false);

  const [search, setSearch] = useState(false);

  const [filters, setFilters] = useState({
    company_id: 0,
    // office_id: 0,
    // province: "",
    name: "",
    surname: "",
    phone: "",
    email: "",
  });

  const [options, setOptions] = useState({
    zones: [],
    status: [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Activo", id: 1 },
      { nombre: "Inactivo", id: -1 },
    ],
    asignTo: [],
    companies: [],
    // offices: [],
  });

  const [loadingOptions, setLoadingOptions] = useState({
    status: false,
    asignTo: false,
    companies: false,
    // offices: false,
  });

  const fetchUsers = useCallback(async () => {
    setFlag(true);
    console.log(setCompanyFromUser);

    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + "/lawyers",
        {
          page: pagePressed,
          objPerPage,
          sortColumn,
          sortDirection,
          ...filters,
          ...(setCompanyFromUser && { company_id: setCompanyFromUser }),
        },
      );

      console.log(response);

      const {
        users,
        companies,
        //  offices, status
      } = response.data;

      if (setCompanyFromUser) {
        setUsersControlNumber(users?.total);
      }

      // if (users.total === 0) {
      //   Swal.fire({
      //     title: "No se han encontrado resultados",
      //     text: "Por favor intente nuevamente con otros párametros.",
      //     icon: "error",
      //     confirmButtonColor: "#1ab394",
      //     cancelButtonColor: "#d33",
      //     reverseButtons: true,
      //     showDenyButton: true,
      //     showConfirmButton: false,
      //     denyButtonText: "Volver",
      //   });
      // }

      setPageCount(users.last_page);
      setTotalPagesNumber(users.total);
      setUser(users.data);
      setOptions((prev) => ({
        ...prev,
        companies,
        // offices
      }));
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setFlag(false);
    }
  }, [pagePressed, objPerPage, search, changeDone, sortColumn, sortDirection]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handlePageClick = (event) => setPagePressed(event.selected + 1);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    if (name === "objPerPage") {
      setObjPerPage(value > totalPagesNumber ? totalPagesNumber : value);
    }
  };

  const renderCellWithDefault = (value, defaultValue = "Sin asignar") => (
    <div className="spanClassForTables centerContent">
      {value || defaultValue}
    </div>
  );

  const renderStatus = (value) => (
    <div className="spanClassForTables centerContent">
      {options.status.find((s) => s.id === value)?.nombre || "Sin asignar"}
    </div>
  );

  const renderLogoCell = (value) => {
    return (
      <div className="spanClassForTables">
        {ImageCell(value) || "Sin asignar"}
      </div>
    );
  };

  const ImageCell = (value) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        justifyContent: "center",
      }}
    >
      <img
        src={`${process.env.REACT_APP_BACKEND_HOST}/storage/company/${value.id}/${value.company_logo}?v=${Date.now()}`}
        alt="Company logo"
        style={{ height: "30px" }}
      />
      {value.id === 1 && <b>{value.company_name}</b>}
    </div>
  );

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE USUARIOS DE EMPRESA",
        columns: [
          {
            Header: "Empresa",
            sortField: "company_name",
            minWidth: 270,
            accessor: "company_relation.company_name",
            Cell: ({ row }) => renderLogoCell(row.original.company_relation),
          },
          // {
          //   Header: "Despacho",
          //   accessor: "offices_relation.office_name",
          //   Cell: ({ value }) => renderCellWithDefault(value),
          // },
          {
            Header: "Nombre y Apellidos",
            sortField: "name",
            minWidth: 200,
            accessor: "full_name",
            Cell: ({ value }) => renderCellWithDefault(value),
          },
          {
            Header: "Teléfono",
            sortField: "phone",
            minWidth: 100,
            accessor: "phone",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN TELÉFONO"),
          },
          {
            Header: "Email",
            sortField: "email",
            accessor: "email",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN CORREO"),
          },
          {
            Header: "Estado",
            sortField: "status",
            accessor: "status",
            Cell: ({ value }) => renderStatus(value),
          },
          {
            Header: "Rol",
            minWidth: 100,
            sortField: "type",
            accessor: "full_rol_name",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN ROL"),
          },
          {
            sortField: "last_login",
            Header: "Última conexión",
            accessor: "last_login",
            Cell: ({ value }) => renderCellWithDefault(value, "SIN FECHA"),
          },
          {
            Header: "Acciones",
            accessor: "id",
            Cell: ({ value }) => (
              <TableActions
                rute={"usuarios"}
                apiRute={"users"}
                value={value}
                showView
                showEdit
                showDelete
                module="users"
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );
  // Cambios dentro del componente Usuarios

  // --- NUEVA FUNCIÓN PARA CARGAR OFICINAS DEPENDIENTES ---
  // const fetchOfficesByCompany = async (companyId) => {
  //   if (!companyId) return;

  //   setLoadingOptions((prev) => ({ ...prev, offices: true }));

  //   try {
  //     let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

  //     const response = await api.post(queryUrl, { company: companyId });

  //     setOptions((prev) => ({
  //       ...prev,
  //       offices: response.data.offices || [],
  //     }));
  //   } catch (error) {
  //     console.error("Error cargando oficinas:", error);
  //   } finally {
  //     setLoadingOptions((prev) => ({ ...prev, offices: false }));
  //   }
  // };

  // --- ACTUALIZAR EL onChange DE EMPRESA ---
  const handleCompanyChange = (_, value) => {
    const companyId = value?.id || 0;

    setFilters((prev) => ({
      ...prev,
      company_id: companyId,
      // office_id: 0, // limpiar oficina
    }));

    // if (companyId) {
    // fetchOfficesByCompany(companyId);
    // } else {
    // si no hay empresa, limpiar oficinas
    // setOptions((prev) => ({ ...prev, offices: [] }));
    // }
  };

  // --- CONFIGURACIÓN DE CAMPOS ACTUALIZADA ---
  const fieldsConfig = [
    {
      type: "autocomplete",
      label: "Empresa",
      options: options.companies,
      loading: loadingOptions.companies,
      onChange: handleCompanyChange,
      getOptionLabel: (option) => option.company_name,
      value: options.companies.find((c) => c.id === filters.company_id) || null,
    },
    // {
    //   type: "autocomplete",
    //   label: "Oficina",
    //   options: options.offices,
    //   loading: loadingOptions.offices,
    //   onChange: (_, value) => handleFilterChange("office_id", value?.id || 0),
    //   getOptionLabel: (option) => option.office_name,
    //   value: options.offices.find((o) => o.id === filters.office_id) || null,
    //   disabled: !filters.company_id, // deshabilitado si no hay empresa
    // },
    {
      type: "text",
      label: "Nombre",
      onChange: (e) => handleFilterChange("name", e.target.value),
      value: filters?.name,
    },
    {
      type: "text",
      label: "Apellido",
      onChange: (e) => handleFilterChange("surname", e.target.value),
      value: filters?.surname,
    },
    {
      type: "text",
      label: "Telefono",
      onChange: (e) => handleFilterChange("phone", e.target.value),
      value: filters?.phone,
    },
    {
      type: "text",
      label: "Email",
      onChange: (e) => handleFilterChange("email", e.target.value),
      value: filters?.email,
    },
  ];

  // --- MODIFICAR EL RENDERIZADO DE AUTOCOMPLETE PARA SOPORTAR "disabled" ---
  const renderField = (field, index) => (
    <Grid
      item
      xs={12}
      md={2}
      key={index}
      sx={{ padding: "5px", justifyContent: "center" }}
    >
      {field.type === "autocomplete" ? (
        <Autocomplete
          className={field.className}
          size="small"
          onChange={field.onChange}
          getOptionLabel={field.getOptionLabel}
          options={field.options}
          loading={field.loading}
          value={field.value}
          disabled={field.disabled || false}
          renderInput={(params) => (
            <TextField
              {...params}
              label={field.label}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {field.loading && (
                      <CircularProgress color="inherit" size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          )}
        />
      ) : (
        <TextField
          onChange={field.onChange}
          label={field.label}
          variant="outlined"
          size="small"
          sx={{ width: "100%" }}
          value={field.value}
        />
      )}
    </Grid>
  );

  const handleFilterStates = () => {
    setFilters({
      company_id: 0,
      // office_id: 0,
      // province: "",
      name: "",
      surname: "",
      phone: "",
      email: "",
      phone: "",
    });
    setSearch(!search);
  };

  const content = (
    <div className="fatherContainer">
      <div className="mainContainer">
        <div className="subMainContainer">
          <Box
            sx={{
              position: "relative",
              background: "white",
              marginBottom: "33px",
              mx: "10px",
              borderRadius: "10px",
            }}
          >
            <Collapse in={showFilters} timeout={400}>
              <Grid
                container
                className="filtersContainer"
                sx={{
                  boxShadow: `0 1px 2px rgba(0,0,0,0.05),0 -8px 38px rgba(0,0,0,0.08)`,
                  justifyContent: "center",
                }}
              >
                {fieldsConfig.map(renderField)}
                <Grid
                  item
                  xs={12}
                  md={12}
                  textAlign="center"
                  mt={1}
                  sx={{
                    display: "inline-flex",
                    gap: "5px",
                    justifyContent: "center",
                  }}
                >
                  <CustomButtonPlusIcon
                    icon={Search}
                    text={"BUSCAR"}
                    handleFunction={() => setSearch(!search)}
                    position={"start"}
                    variant={"outlined"}
                    color={"info"}
                  />
                  <CustomButtonPlusIcon
                    icon={CleaningServices}
                    text={"LIMPIAR FILTROS"}
                    handleFunction={handleFilterStates}
                    position={"start"}
                    variant={"outlined"}
                    color={"error"}
                  />
                </Grid>
              </Grid>
            </Collapse>

            {/* BOTÓN FLOTANTE */}
            <Box
              sx={{
                position: "absolute",
                bottom: showFilters ? "-26px" : "-16px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
              }}
            >
              <Button
                variant="contained"
                size="small"
                onClick={() => setShowFilters(!showFilters)}
                endIcon={
                  showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                }
                sx={{
                  minWidth: "220px",
                  height: "25px",
                  borderRadius: "0px 0px 10px 10px",
                  boxShadow: 3,
                  textTransform: "none",
                  fontWeight: 500,
                }}
              >
                {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
              </Button>
            </Box>
          </Box>
          {(user === "" || flag) && (
            <LoadingPage isLoading={flag} heightProp={"60vh"} />
          )}
          {user && !flag && (
            <Table
              columns={columns}
              data={user}
              view={"usuario"}
              viewTitle={"usuarios"}
              totalPagesNumber={totalPagesNumber}
              icon={PersonAdd}
              apiRoute={"users"}
              // pagination
              onPageChange={handlePageClick}
              pageCount={pageCount}
              forcePage={pagePressed - 1} // Esto sincroniza el botón activo
              // SORT
              onSort={handleSort}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              tableWidth="unset"
              minTableWidth="80%"
              viewPermission={"users"}
              setChangeDone={setChangeDone}
              changeDone={changeDone}
            />
          )}
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  return (
    <>
      {flagToShow ? (
        <div>
          <CommonSubHeader title="Configuración" subTitle="Usuarios" />

          {content}
        </div>
      ) : (
        <div className="fatherContainer">
          <div className="mainContainer">{content}</div>
        </div>
      )}
    </>
  );
}

export default Usuarios;
